import React, { Component } from 'react';
import {
  SafeAreaView,
  View,
  Text,
  TextInput,
  Image,
  TouchableOpacity,
} from 'react-native';

//import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
//import Ionicons from 'react-native-vector-icons/Ionicons';


import { FontAwesome5, Feather, MaterialIcons, Ionicons } from '@expo/vector-icons'
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';

import CustomButton from './CustomButton';
import InputField from './InputField';
import { Card } from "@rneui/themed";
import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from "moment";

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
            loginLoad: false,
            email: '',
            password: '',
            isLoggedIn: false,
            data: [],
            
            
        }

        
  
      }
      componentDidMount() {
        showLoader();
        //get user from asyncstorage
        AsyncStorage.getItem('user').then((user) => {
          if (user) {
            //parse json
            user = JSON.parse(user);
            //console.log(user.email)
          
            this.setState({isLoggedIn: true, data: user});
        hideLoader()
          } else {
           // this.setState({isLoggedIn: false});
            hideLoader()
          }
        }).catch((err) => {
          console.log(err);
        }
        );
        

      }
        login = () => {
          showLoader();
          //construct get data for url
         // console.log(this.state.email)
          const data = '?email=' + this.state.email + '&password=' + this.state.password;
          //fetches data from the server
         
          fetch('http://ios.breketefamily.com/login.php' + data,
            { method: 'GET' })
            .then((response) => response.json())
            .then((responseJson) => {
              // console.log(responseJson)
              if (responseJson.status == 0 && responseJson.message == 'login successful') {
            
                //add responseJson.data to asyncstorage and state
                try {
                 AsyncStorage.setItem('user', JSON.stringify(responseJson.data));
                 console.log(responseJson.data)
                  this.setState({isLoggedIn: true, data: responseJson.data});
                 alert('login successful')
                } catch (e) {
                  console.log('Unable to Save User Details, ' + e);
                }
                hideLoader();

              }else{
                hideLoader();
                this.setState({isLoggedIn: false})
                alert(responseJson.message)
              } 
            })
            .catch((error) => {
              console.error(error);
            });
          }

      loginForm = () => {
        
        return (
           <View style={{paddingHorizontal: 25}}>
              
            <AppLoader ref = { loaderRef } />
              <View style={{alignItems: 'center'}}>
                <Image
                  source={require('../assets/images/Splash.png')}
                 
                  style={{ height:200,
                  width:200}}
                />
              </View>
      
              <Text
                style={{
                  fontFamily: 'Roboto-Medium',
                  fontSize: 28,
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: 30,
                }}>
                Login
              </Text>
      
              <View
            style={{
              flexDirection: 'row',
              borderBottomColor: '#ccc',
              borderBottomWidth: 1,
              paddingBottom: 8,
              marginBottom: 25,
            }}>
           <MaterialIcons
                  name="alternate-email"
                  size={20}
                  color="#666"
                  style={{marginRight: 5}}
                />
           
              <TextInput
                placeholder={'Email'}
                keyboardType={'email-address'}
                style={{flex: 1, paddingVertical: 0}}
                onChangeText={(email) => {
                 // console.log(email)
                  this.setState({email})
                }}
              />
          
          </View> 
      
          
          <View
            style={{
              flexDirection: 'row',
              borderBottomColor: '#ccc',
              borderBottomWidth: 1,
              paddingBottom: 8,
              marginBottom: 25,
            }}>
            <Ionicons
                  name="ios-lock-closed-outline"
                  size={20}
                  color="#666"
                  style={{marginRight: 5}}
                />
              <TextInput
                placeholder={'Password'}
                keyboardType={'password'}
                secureTextEntry = {true}
                style={{flex: 1, paddingVertical: 0}}
                onChangeText={(password) => {
                //  console.log(password)
                  this.setState({password})
                }}
              />
          
          </View> 
            
      
      
              <CustomButton label="Login"
                      onPress={()=>{this.login()}}
                      />
      
              <Text style={{textAlign: 'center', color: '#666', marginBottom: 30}}>
                Or, login with ...
              </Text>
      
             
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginBottom: 30,
                }}>
                <Text>New to the app?</Text>
                <TouchableOpacity onPress={() => navigation.navigate('Register')}>
                  <Text style={{color: '#AD40AF', fontWeight: '700'}}> Register</Text>
                </TouchableOpacity>
              </View>
            </View>
       
        )
              }
        
              
      renderLoggedIn = () => {
        return (
             <View style={{paddingHorizontal: 25}}>
              <View style={{alignItems: 'center'}}>
                <Text style={{fontSize: 28, fontWeight: '500', color: '#333'}}>
                  Welcome back {this.state.data.name}!
                </Text>
                <Card>
          <Card.Title>{this.state.data['0'].plan}</Card.Title>
          <Card.Divider />
          <Text style={{flex:1}}>
            Expiry Date: {this.state.data.exp_date}
          </Text>
        </Card>
                <CustomButton label={'Logout'}
           onPress={()=>{
            this.setState({isLoggedIn: false})
            AsyncStorage.removeItem('user');
           }} />
              </View>
              </View>
        );
      }

    

      render() {
        console.log(this.state.loggedIn)
          
        return (
          <SafeAreaView style={{flex: 1, justifyContent: 'center'}}>
           {this.state.isLoggedIn && this.renderLoggedIn()}
           {!this.state.isLoggedIn && this.loginForm()}
          
            </SafeAreaView>    
        )
};

};
